import { Navigate } from 'react-router-dom';
import Login from '@/app/auth';
import PasswordReset from '@/app/auth/password-reset';
import { ROUTES } from '@/constants';

export const publicRoutes = () => {
  const routes = [
    {
      path: ROUTES.login,
      element: <Login />,
    },
    {
      path: ROUTES.passwordReset,
      element: <PasswordReset />,
    },
    {
      path: ROUTES.notFound,
      element: <Navigate replace to={ROUTES.login} />,
    },
  ];

  return routes;
};
